<img src="/assets/images/logo.png" alt="KVVM" width="250" height="83">
<form [formGroup]="getTokenForm" (ngSubmit)="authenticationService.lostPasswordCreateToken(getTokenForm.value)">
	<mat-form-field>
		<input title="" matInput placeholder="E-mail" type="email" name="email" required formControlName="email" autocomplete="email">
		<mat-error *ngIf="formsService.getFieldError('email')">{{formsService.getFieldError('email')}}</mat-error>
	</mat-form-field>
	<button color="primary" mat-button [disabled]="!getTokenForm.valid">WACHTWOORD HERSTELLEN</button>
</form>
<a [routerLink]="['/login']">Terug naar login scherm</a>
